export const sectionConstants = {
  ADD_SECTION_REQUEST: "ADD_SECTION_REQUEST1",
  ADD_SECTION_SUCCESS: "ADD_SECTION_SUCCESS1",
  ADD_SECTION_FAILURE: "ADD_SECTION_FAILURE1",

  GET_SECTION_REQUEST: "GET_SECTION_REQUEST1",
  GET_SECTION_SUCCESS: "GET_SECTION_SUCCESS1",
  GET_SECTION_FAILURE: "GET_SECTION_FAILURE1",

  DELETE_SECTION_REQUEST: "DELETE_SECTION_REQUEST1",
  DELETE_SECTION_SUCCESS: "DELETE_SECTION_SUCCESS1",
  DELETE_SECTION_FAILURE: "DELETE_SECTION_FAILURE1",

  GET_SECTIONS_REQUEST: "GET_SECTIONS_REQUEST1",
  GET_SECTIONS_SUCCESS: "GET_SECTIONS_SUCCESS1",
  GET_SECTIONS_FAILURE: "GET_SECTIONS_FAILURE1",

  TOGGLE_SECTION_STATUS_REQUEST: "TOGGLE_SECTION_STATUS_REQUEST1",
  TOGGLE_SECTION_STATUS_SUCCESS: "TOGGLE_SECTION_STATUS_SUCCESS1",
  TOGGLE_SECTION_STATUS_FAILURE: "TOGGLE_SECTION_STATUS_FAILURE1",

  GET_SECTION_SUBCOURSES_REQUEST: "GET_SECTION_SUBCOURSES_REQUEST",
  GET_SECTION_SUBCOURSES_FAILURE: "GET_SECTION_SUBCOURSES_FAILURE",
  GET_SECTION_SUBCOURSES_SUCCESS: "GET_SECTION_SUBCOURSES_SUCCESS",

  CHANGE_SECTION_NAME_REQUEST: "CHANGE_SECTION_NAME_REQUEST1",
  CHANGE_SECTION_NAME_SUCCESS: "CHANGE_SECTION_NAME_SUCCESS1",
  CHANGE_SECTION_NAME_FAILURE: "CHANGE_SECTION_NAME_FAILURE1",

  CHANGE_SECTION_DISPLAY_NAME_REQUEST: "CHANGE_SECTION_DISPLAY_NAME_REQUEST1",
  CHANGE_SECTION_DISPLAY_NAME_SUCCESS: "CHANGE_SECTION_DISPLAY_NAME_SUCCESS1",
  CHANGE_SECTION_DISPLAY_NAME_FAILURE: "CHANGE_SECTION_DISPLAY_NAME_FAILURE1",

  CHANGE_SECTION_PARENT_REQUEST: "CHANGE_SECTION_PARENT_REQUEST1",
  CHANGE_SECTION_PARENT_SUCCESS: "CHANGE_SECTION_PARENT_SUCCESS1",
  CHANGE_SECTION_PARENT_FAILURE: "CHANGE_SECTION_PARENT_FAILURE1",

  CHANGE_SECTION_STARS_REQUEST: "CHANGE_SECTION_STARS_REQUEST1",
  CHANGE_SECTION_STARS_SUCCESS: "CHANGE_SECTION_STARS_SUCCESS1",
  CHANGE_SECTION_STARS_FAILURE: "CHANGE_SECTION_STARS_FAILURE1",

  CHANGE_SECTION_NODE_REQUEST: "CHANGE_SECTION_NODE_REQUEST1",
  CHANGE_SECTION_NODE_SUCCESS: "CHANGE_SECTION_NODE_SUCCESS1",
  CHANGE_SECTION_NODE_FAILURE: "CHANGE_SECTION_NODE_FAILURE1",

  DELETE_SECTION_NODE_REQUEST: "DELETE_SECTION_NODE_REQUEST1",
  DELETE_SECTION_NODE_SUCCESS: "DELETE_SECTION_NODE_SUCCESS1",
  DELETE_SECTION_NODE_FAILURE: "DELETE_SECTION_NODE_FAILURE1",

  GET_SECTION_LESSONS_REQUEST: "GET_SECTION_LESSONS_REQUEST1",
  GET_SECTION_LESSONS_SUCCESS: "GET_SECTION_LESSONS_SUCCESS1",
  GET_SECTION_LESSONS_FAILURE: "GET_SECTION_LESSONS_FAILURE1"
}
